import { render, staticRenderFns } from "./Debits.vue?vue&type=template&id=1cd70a85&scoped=true"
import script from "./Debits.vue?vue&type=script&lang=js"
export * from "./Debits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd70a85",
  null
  
)

export default component.exports